import { useState } from 'react';

export default function AutoDebitModel() {
  const [selectedAccount, setSelectedAccount] = useState<any>(null); // 左侧选中账户

  return {
    selectedAccount,
    setSelectedAccount,
  };
}
